import { FRONTEND_PROPERTY_NAME, SYSTEM_NODES, } from '../../common/constants.js';
export function validateErrorHandlerNode(nodeFields, accept) {
    const { idField, nodeTypeField } = nodeFields;
    // The node number should be correct
    if (nodeFields.refNode.name !== SYSTEM_NODES.ERROR_HANDLER_NODE) {
        accept('error', `Error handler command must only be used in the error handler system node.`, {
            node: nodeFields.refNode,
            data: {
                id: idField?.id?.value,
                nodeNumber: nodeFields.refNode.name,
                propertyName: FRONTEND_PROPERTY_NAME.COMMAND,
            },
        });
    }
    // The node should be an action node
    if (nodeTypeField?.nodeType?.value !== 'A') {
        accept('error', `Error handler node must be an action node.`, {
            node: nodeFields.refNode,
            data: {
                id: idField?.id?.value,
                nodeNumber: nodeFields.refNode.name,
                propertyName: FRONTEND_PROPERTY_NAME.NODE_TYPE,
            },
        });
    }
}
//# sourceMappingURL=error-handler.js.map